import React, { useState } from "react";
import { MarketplaceDetailContent } from "../../blocks/marketplace-detail-content";
import { Header } from "../../components/Header";
import { useParams } from "react-router";
import "./styles.less";
import { useTranslation } from "react-i18next";
import { HomeTryOn } from "../../blocks/home-try-on";
import { useEffectOnce } from "react-use";
import Axios from "axios";
import { useEffect } from "react";
import { Footer } from "../../components/Footer";

export const MarketplaceDetailPage = (props) => {
  const { id } = useParams();
  const { t } = useTranslation();
  const { macketplaceDetailData } = props;
  const [detail, setDetail] = useState(macketplaceDetailData);

  const esignApp = {
    name: "e签宝",
    nameI18n: { "zh-CN": "e签宝", "en-US": "eSign" },
    logo:
      "https://files.authing.co/authing-console/application-templates/logo/ESIGN.png",
    categories: ["project-management"],
    protocol: "oidc",
    descriptionI18n: {
      "zh-CN":
        "e签宝是中国互联网电子签名行业领跑者。致力于为客户提供具有法律效力的电子合同全生命周期服务，将原本需要耗费数日之久的文件签署环节，压缩到只需几十秒。",
      "en-US":
        "eSign is a leader in China's Internet electronic signature industry. It is committed to providing customers with legally effective electronic contract full life cycle services, reducing the document signing process that would otherwise take several days to just tens of seconds.",
    },
    website: "https://www.atlassian.com",
    overviewImg:
      "https://files.authing.co/authing-website/marketplace-preview-eqianbao.png",
  };
  useEffect(() => {
    console.log(id);
    if (id === "esign") {
      setDetail(esignApp);
    }
  }, [id, esignApp]);
  useEffect(() => {
    if (id !== "esign") {
      Axios.get(`/api/marketplace-detail?identifier=${id}`).then((res) => {
        setDetail(res?.data?.data || {});
      });
    }
  }, [id]);

  return (
    <div className="marketplace-detail-page">
      <Header />
      <MarketplaceDetailContent data={detail} id={id} />
      <Footer />
    </div>
  );
};
